import { css } from "styled-components";

import { BTTO_PROFILE_COLORS } from "./elements";

export const bettoWalletPrimaryButtonStyles = css`
	border-radius: 8px !important;
	background: ${BTTO_PROFILE_COLORS.primary} !important;
	color: ${BTTO_PROFILE_COLORS.primaryText} !important;
	font-size: 13px !important;
	font-weight: 600 !important;
	height: 44px !important;
	min-height: 44px !important;
	letter-spacing: 0 !important;
	border: none !important;
	cursor: pointer;
	text-decoration: none !important;
	transition: background 0.2s ease;

	&:hover {
		background: ${BTTO_PROFILE_COLORS.primaryDark} !important;
		color: ${BTTO_PROFILE_COLORS.primaryText} !important;
	}

	svg {
		width: 16px !important;
		height: 16px !important;
		margin: 0 0 0 6px !important;
		flex-shrink: 0;
	}
`;

export const bettoWalletSectionTitleStyles = css`
	justify-content: flex-start;
	border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
	border-radius: 10px !important;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
	color: ${BTTO_PROFILE_COLORS.text} !important;
	font-size: 13px !important;
	font-weight: 600 !important;
	line-height: 1.3 !important;
	padding: 12px 16px !important;
	margin-bottom: 16px;
`;

export const bettoWalletBonusOptionStyles = css`
	width: 100% !important;
	height: auto !important;
	min-height: 44px;
	padding: 12px 14px;
	gap: 12px;
	border-radius: 10px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	transition:
		border-color 0.2s ease,
		background 0.2s ease;

	&:hover {
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
	}

	${({ isBonusSelected }) =>
		isBonusSelected &&
		css`
			border-color: ${BTTO_PROFILE_COLORS.borderActive};
			background: rgba(3, 98, 212, 0.08);
		`}
`;

export const bettoWalletBonusRadioStyles = css`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 18px !important;
	height: 18px !important;
	min-width: 18px;
	border-radius: 50% !important;
	border: 1.5px solid #485370 !important;
	background: transparent !important;
	flex-shrink: 0;

	${({ isBonusSelected }) =>
		isBonusSelected &&
		css`
			border-color: ${BTTO_PROFILE_COLORS.borderActive} !important;
			background: ${BTTO_PROFILE_COLORS.borderActive} !important;
			position: relative;

			&::before {
				content: "";
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 6px !important;
				height: 6px !important;
				border-radius: 50% !important;
				background: #ffffff !important;
			}
		`}
`;

export const bettoWalletBonusTextStyles = css`
	color: ${BTTO_PROFILE_COLORS.textMuted} !important;
	font-size: 14px !important;
	font-weight: 500 !important;
	line-height: 1.3 !important;

	${({ isBonusSelected }) =>
		isBonusSelected &&
		css`
			color: ${BTTO_PROFILE_COLORS.text} !important;
		`}
`;

export const bettoWalletBonusContainerStyles = css`
	flex-direction: column !important;
	gap: 8px !important;
`;

export const bettoWalletExternalDescriptionStyles = css`
	color: ${BTTO_PROFILE_COLORS.textMuted} !important;
	font-size: 13px !important;
	font-weight: 500 !important;
	line-height: 1.5 !important;
	text-align: left !important;
`;

export const bettoWalletCautionStyles = css`
	color: ${BTTO_PROFILE_COLORS.textDim} !important;
	font-size: 11px !important;
	line-height: 1.4 !important;
	padding-left: 0 !important;
`;
